var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isMember())?_c('navigation-menu-member'):(_vm.userMode == 'MANAGE')?_c('navigation-menu-manager'):(_vm.userMode == 'MENTOR')?_c('navigation-menu-mentor'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }